import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import Skeleton from '@jimmyboys/liita-ui/dist/components/Skeleton'
import React, { memo } from 'react'

import PostIt from 'components/PostIt/PostIt'
import TaskStatus from './TaskStatus'
import { Link } from 'react-router-dom'
import Tooltip from '@jimmyboys/liita-ui/dist/components/Tooltip'

import styles from './UserTaskRow.module.sass'

const UserTaskRow = memo(
	(props) => {
		const { data, className, ...attributes } = props
		const Tag = data.link ? Link : 'div'
		const to = data.link?.to
		const dueDate = data.dueDate?.dateTimeFormat

		return (
			<div
				{...attributes}
				className={`${styles['row'] || ''} ${className || ''} ${
					data.editing ? styles['is-active'] || '' : ''
				}`}
			>
				{data.note && (
					<PostIt
						className={styles['note']}
						data={{ text: data.note, type: 'sliding' }}
					/>
				)}
				<Tag className={styles['link']} to={to}>
					<span className={styles['icon-cell']}>
						<span className={styles['icon-container']}>
							<Icon
								className={styles['icon']}
								height='20px'
								width='20px'
								name={data.icon}
							/>
						</span>
					</span>
					<span className={styles['task-type']}>
						<div>
							<h5>{data.requisitionType?.name || data.title}</h5>
							{data.requisitionId && (
								<small>#{data.requisitionId}</small>
							)}
						</div>
					</span>
					<span className={styles['details']}>
						<div>
							<h5>
								{data.segment?.abbreviation} -{' '}
								{data.insuranceCompany?.shortName} (
								{data.insurancePolicy?.externalId ||
									data.insurancePolicy?.tempId ||
									'-'}
								)
							</h5>
							<small>{data.provider?.name}</small>
						</div>
					</span>
					<span className={styles['injured']}>
						<div>
							<h5>{data.injured?.name}</h5>
							<small>#{data.processId}</small>
						</div>
					</span>
					<span>
						<div className={styles['inner-table']}>
							<span className={`${styles[data.priority.name]}`}>
								<Tooltip
									text={data.$labels[data.priority.name]}
								>
									<Icon
										className={styles['icon']}
										name={data.priority.name}
										height='24px'
										width='24px'
									/>
								</Tooltip>
							</span>
							<span>
								<TaskStatus
									status={
										data.isComplete
											? 'complete'
											: data.dueDate?.dueStatus
									}
									className={styles['status-icon']}
								/>
							</span>
							<span>
								<Icon
									className={styles['icon']}
									name='calendar'
									height='24px'
									width='24px'
								/>
							</span>
							<span>
								<small>{dueDate}</small>
							</span>
						</div>
					</span>
				</Tag>
			</div>
		)
	},
	(prevProps, nextProps) =>
		prevProps.data.id === nextProps.data.id &&
		prevProps.style.top === nextProps.style.top
)

export const LoadingUserTaskRow = (props) => {
	const { className, ...attributes } = props
	return (
		<div
			{...attributes}
			className={`${styles['row-skeleton']} ${className || ''}`}
		>
			<span className={styles['icon']}>
				<Skeleton className={styles['skeleton']} />
			</span>
			<span className={styles['task-type']}>
				<h5>
					<Skeleton
						className={`${styles['skeleton']} ${styles['smaller']}`}
					/>
				</h5>
				<small>
					<Skeleton
						className={`${styles['skeleton']} ${styles['small']}`}
					/>
				</small>
			</span>
			<span className={styles['details']}>
				<h5>
					<Skeleton
						className={`${styles['skeleton']} ${styles['smaller']}`}
					/>
				</h5>
				<small>
					<Skeleton
						className={`${styles['skeleton']} ${styles['small']}`}
					/>
				</small>
			</span>
			<span className={styles['injured']}>
				<h5>
					<Skeleton
						className={`${styles['skeleton']} ${styles['smaller']}`}
					/>
				</h5>
				<small>
					<Skeleton
						className={`${styles['skeleton']} ${styles['small']}`}
					/>
				</small>
			</span>
			<span>
				<small>
					<Skeleton
						className={`${styles['skeleton']} ${styles['small']}`}
					/>
				</small>
			</span>
		</div>
	)
}

export default UserTaskRow
